var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148584",
    "data-name": "Rectangle 148584",
    width: 24,
    height: 24,
    transform: "translate(420 419)",
    fill: "#7a4b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-420 -419)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(423.116 422.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11708",
    "data-name": "Group 11708",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_41",
    "data-name": "Union 41",
    d: "M-5865.918,15609.754a.671.671,0,0,1-.188-.6l.807-4.345a.671.671,0,0,1,.184-.353l11.98-11.98a2.012,2.012,0,0,1,1.442-.595,2.006,2.006,0,0,1,1.438.591l1.61,1.61a2.022,2.022,0,0,1,.6,1.441,2.016,2.016,0,0,1-.6,1.442l-11.98,11.979a.673.673,0,0,1-.349.185l-4.349.807a.636.636,0,0,1-.121.012A.654.654,0,0,1-5865.918,15609.754Zm1.308-1.309,2.135-.4-1.739-1.739Zm.917-3.511,2.593,2.594,10.033-10.033-2.594-2.6Zm11.506-11.506-.525.521,2.593,2.6.525-.524a.7.7,0,0,0,0-.983l-1.61-1.61a.679.679,0,0,0-.49-.2A.688.688,0,0,0-5852.187,15593.429Z",
    transform: "translate(5865.966 -15592.033)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.648892c2.svg";
export { ForwardRef as ReactComponent };